import { render, staticRenderFns } from "./SingleTopic.vue?vue&type=template&id=4121ae05&scoped=true&"
import script from "./SingleTopic.vue?vue&type=script&lang=js&"
export * from "./SingleTopic.vue?vue&type=script&lang=js&"
import style0 from "./SingleTopic.vue?vue&type=style&index=0&id=4121ae05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4121ae05",
  null
  
)

export default component.exports